import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-backtester',
  standalone: true,
  templateUrl: './backtester.component.html',
  styleUrls: ['./backtester.component.scss'],
  imports: [CommonModule]
})
export class BacktesterComponent implements OnInit {
  tableData: any = []
  updateKO: boolean = false
  updateOK: boolean = false
  markets: any = []
  logMarkets: string = ''
  
  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.listamercati()
  }

  listamercati(){
    this.service.backtestMarkets().subscribe( ( data: any) => {
      data['data'].forEach((element:any) => {
        element.update = ""
      });
      this.markets = data['data']
      console.log(this.markets)
    })
  }

  backtester(){
    let tot = 0
    this.updateKO = false
    this.updateOK = false
    /* this.service.backtest(this.markets[0].market).subscribe(data => {
      console.log(data)
    })
    return */
    this.markets.forEach((element: any) => {
      this.service.backtest(element.market) .subscribe( (data:any) => {
        console.log(data)
        if(data['msg']=='ok'){
          tot++ 
          element.update = "Completato!"
        }else{
          this.updateKO = true
          console.log(data)
        }
      })
    });
    this.updateOK = true
  }

  backtester_1(){
    let tot = 0
    this.updateKO = false
    this.updateOK = false
    this.service.backtest('audchf') .subscribe( (data: any) => {
      console.log(data)
      if(data['msg']=='ok'){
        this.updateOK = true
        this.listamercati()
      }else{
        this.updateKO = true
        console.log(data)
      }
    })
  }

  sortBy(id: any){}
}
